import { useContext } from 'react';
import { OpenIdContext, IOpenIdContext } from './OpenIdContext';

export const useOpenId = () => useContext<IOpenIdContext>(OpenIdContext);
